import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { License } from '../models/License';
import { getLicenses, hasActiveLicense, isStaff } from '../services/license.service';
import vrLogo from "../assets/images/vexcode-vr-logo.svg"
import { userLogout } from '../services/auth.service';

interface LinkItem {
  label: string,
  path: string,
  activeClass: 'active' | '',
  itemClass: string
}

function Navigation() {

  const menuItems: LinkItem[] = [
    {
      label: 'Home',
      path: '/home',
      activeClass: 'active',
      itemClass: 'nav-home'
    },
    {
      label: 'Classes',
      path: '/classes',
      activeClass: '',
      itemClass: 'nav-classes'
    },
    {
      label: 'Sharing',
      path: '/service',
      activeClass: '',
      itemClass: 'nav-services'
    },
    {
      label: 'Offline',
      path: '/offline',
      activeClass: '',
      itemClass: 'nav-offline'
    },
    {
      label: 'Analytics',
      path: '/analytics',
      activeClass: '',
      itemClass: 'nav-admin'
    }
  ]
  const [navLinks, setNavLinks] = useState<LinkItem[]>(menuItems)

  const location = useLocation()
  const navigate = useNavigate()

  async function logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('userId')
    localStorage.removeItem('dropbox')
    await userLogout()
    navigate('/login')
  }
  
  function setNavigationForOthers(licenses: License[]) {
    if (isStaff(licenses)) {
      const linkSet = setActiveLink(menuItems)
      setNavLinks([...linkSet])
    } else if (hasActiveLicense(licenses)) {
      const linkSet = setActiveLink(menuItems.filter(item => item.label !== 'Analytics'))
      setNavLinks([...linkSet])
    } else {
      setNavigationForUnlicensed()
    }
  }

  function setActiveLink(links: LinkItem[]) {
    return links.map(link => {
      link.activeClass = ''
      if (location.pathname === link.path) {
        link.activeClass = 'active'
      }
      return link
    })
  }

  function setNavigationForUnlicensed() {
    let linkSet = menuItems.filter(menuItem => menuItem.label === 'Home' || menuItem.label === 'Offline')
    linkSet = setActiveLink(linkSet)
    setNavLinks([...linkSet])
  }

  function setNavigationLinks() {
    const licenses = getLicenses()
    if (licenses.length > 0) {
      return setNavigationForOthers(licenses)
    }
    return setNavigationForUnlicensed()
  }

  useEffect(() => {
    setNavigationLinks()
  }, [location])

  return (
    <div className="vexcodevr-navbar navbars navbar-expand-lg navbar-light">
      <div className="container-fluid my-4 my-lg-0">
        <div className='row w-100'>
          <div className="col-2 col-lg-12">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#vexcodeVRNavbar" aria-controls="vexcodeVRNavbar" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div className="col-10 col-lg-12">
            <img src={vrLogo} alt="VEXcode VR Logo" className="nav-vexcodevr-logo img-fluid" />
          </div>
        </div>
      </div>

      <div className="collapse navbar-collapse" id="vexcodeVRNavbar">
        <ul className="navbar-nav2 me-auto mb-2 mb-lg-0 w-100">
          {navLinks && navLinks.map(link =>
            <li className={`nav-item ${link.itemClass} ${link.activeClass}`} key={link.path}>
              <Link className={`nav-link ${link.activeClass}`} to={link.path}>{link.label}</Link>
            </li>
          )}
          <li className="nav-item nav-logout">
            <button className="nav-link" onClick={() => logout()}>Logout</button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Navigation;